import { ProgressApi } from '../../shared/api/progressApi.ts'
import { proxy } from 'valtio'
import { IFilteredMetrics, filterMetrics } from '../../shared/lib/utils.ts'
import { AppLocalStorage } from '../../shared/lib/appLocalStorage.ts'

interface State {
  metrics: IFilteredMetrics
}

export class ProgressStore {
  state: State

  constructor(
    private progressApi: ProgressApi,
    private appStorage: AppLocalStorage,
  ) {
    this.state = proxy<State>({
      metrics: {},
    })
  }

  async getAllMetrics() {
    const courseId = this.appStorage.get('currentCourse')?.id
    const data = await this.progressApi.getMetrics(courseId)
    this.state.metrics = filterMetrics(data)
  }
}
